cafm.ds = {

    createSearchDataSource: function (args) {

        var w = args.wrapper,
            dse = args.element,
            o = args.options,
            crit = dse.getCriteria() || o.Criteria,
            page;

        if (isUndefined(w)) {

            w = args.element.parent();
        }

        if (crit) {

            page = cafm.ds.currentPage.get(crit);
        }

        var ds, dso = {
            transport: {
                read: function (dsOpts) {

                    crit = dse.getCriteria() || o.Criteria;
                    var c = args.control(),
                        isGrd = dse.hasClass('k-grid'),
                        isLst = dse.hasClass('k-listview');

                    if (cafm.handlers.exists('cafm.searchCriteria')) {

                        crit = cafm.handlers.exe('cafm.searchCriteria', crit);
                    }

                    if (isGrd && !dse.data('ResettingSearch')) {

                        if (o.Sortable) {

                            cafm.ds.ensureGridSortOptionsOnCriteria(c, crit);
                        }

                        if (o.Groupable) {

                            cafm.ds.ensureGridGroupOptionsOnCriteria(c, crit);
                        }
                    }

                    // if there's some criteria and we're using server paging
                    // set the page size and the current page
                    if (crit && o.UseServerPaging) {
                        crit.PageSize = c.dataSource.pageSize();
                        crit.Page = c.dataSource.page();
                    }

                    // cache criteria if cacheable
                    cafm.cache.addObject(crit);

                    var dsRead = function (r, m)
                    {
                        var t, // total
                            res = r; // response

                        // get the total
                        if (isNum(r.Total)) {

                            t = r.Total;
                        }

                        // reference the data items
                        if (r && r.Items) {

                            r = r.Items;
                        }
                        // set total from array length if total wasn't provided explicitly in the response
                        if (isUndefined(t)) {

                            t = r.length;
                        }

                        // cache total on the datasource element (grid/list etc)
                        dse.data('total', t);
                        
                        // if there's criteria enter page number caching code
                        if (crit) {

                            // check for page from search results response
                            if (res && res.Page && crit.PageSize) {

                                page = res.Page;

                                if(res.Page != crit.Page) {

                                    ds.page(res.Page);
                                }
                            }
                            // otherwise check the criteria
                            else if (crit.Page) {

                                page = crit.Page;
                            }

                            // if we have a page number then cache it
                            if (isNum(page)) {

                                cafm.ds.currentPage.set(crit, page);
                            }
                        }

                        // workaround for kendo bug: https://github.com/telerik/kendo-ui-core/issues/4092 - kendo proposed fix in 2018.R2 when released
                        if (o.EnablePaging !== false && o.PageSize && ds.pageSize() != o.PageSize) {
                            ds.pageSize(o.PageSize);
                        }
                        
                        // execute on data retrieved handler
                        if (o.OnDataRetrieved) {

                            var ret = cafm.handlers.exe(o.OnDataRetrieved, r, dse);
                            if (ret) {
                                r = ret;
                            }
                        }

                        // show the datasource element
                        dse.show();
                        $('.msgPnl', w).hideMessage();

                        // cache object if applicable (handled inside addObject)
                        if (res) {

                            cafm.cache.addObject(res);
                        }

                        // fire success handler
                        dsOpts.success(r);

                        if (t < 1) {

                            if (isGrd) {

                                cafm.CAFMReactDOM.Components.GridColumnChooser.toggle(false, w);
                                cafm.grids.showEmptyGrid(o);
                            }
                            else if (isLst) {

                                cafm.lv.showNoItems(w, o);
                            }

                            if (!o.AllowInlineCreate) {

                                dse.hide();
                            }
                        }
                        else {

                            if (isGrd) {

                                cafm.CAFMReactDOM.Components.GridColumnChooser.toggle(true, w);
                            }
                            else if (isLst) {

                                $('.listview-noitems', w).hide();
                            }

                            dse.show();
                        }

                        var onDataSourceRead = dse.data('onDataSourceRead');
                        if (isFunc(onDataSourceRead)) {

                            // call the on data source read function
                            onDataSourceRead(r);
                        }

                        // ensure the current page is always visible by determining max page
                        var maxPage = Math.ceil(c.dataSource.total() / c.dataSource.pageSize());

                        // ensure max page is at least 1
                        if (maxPage < 1) maxPage = 1;

                        // if previous page selection was larger then reset the page
                        if (maxPage < c.dataSource.page()) {

                            c.dataSource.page(maxPage);
                        }
                    }

                    // try getting cache data if an offline widget
                    var data;
                    if (o.DataSourceData) {
                        
                        data = o.DataSourceData;
                    }
                    else if (o.DataSourceFunction) {

                        // try getting the data
                        data = cafm.util.callFunction(o.DataSourceFunction, o.ParentEntityId);

                        if (data && isFunc(data.toJSON)) {

                            data = data.toJSON();
                        }
                    }
                    else if (cafm.isOffline() && o.DataSourceFallback) {

                        // try getting the data
                        data = cafm.util.callFunction(o.DataSourceFallback);

                        if (data && isFunc(data.toJSON)) {

                            data = data.toJSON();
                        }
                    }
                    else if (o.BoundViewModelCollection) {

                        var viewModel = dse.getParentViewModel();
                        data = viewModel.get(o.BoundViewModelCollection);

                        if (data && isFunc(data.toJSON)) {

                            data = data.toJSON();
                        }
                    }

                    // if there's cache data use that
                    if (isArray(data)) {

                        // execute on ds read logic with cache data
                        dsRead(data);
                    }
                    else { // otherwise go off to the server
                           
                        var processData = function (data) {

                            // client side filtering
                            if (o.ClientFilters) {

                                return cafm.filters.client.filter({
                                    criteria: crit,
                                    data: data,
                                    filters: o.ClientFilters
                                });
                            }
                            else {

                                return data;
                            }
                        }

                        // get the data by executing the action
                        cafm.actions.execute({
                            context: o.RequestContext,
                            url: o.DataSourceUrl,
                            method: o.DataSourceHttpMethod,
                            values: crit,
                            elementId: o.ClientId,
                            loaderSelector: '#{0}'.format(o.ClientId),
                            timeout: o.DataSourceTimeout,
                            preventValidate: true,
                            beforeExecute: function (args) {

                                // check for pre data source read handler
                                var be = o.OnBeforeExecute;

                                // if there is a handler then call and return it
                                // if false then the request will be stopped
                                if (be) {

                                    return cafm.util.callFunction(be, args);
                                }
                                else {

                                    return true;
                                }
                            },
                            beforeSend: function (r, s, action) {

                                // set request active flag
                                dse.data('requestActive', true);

                                // remove the offline flag on the widget
                                dse.removeData('offlineWidget');

                                var preDsRead = dse.data('predatasourceread');

                                // if string try getting the function
                                if (isStr(preDsRead)) {

                                    preDsRead = cafm.util.getReference(preDsRead);
                                }

                                // if there's a function reference then call it
                                if (isFunc(preDsRead)) {

                                    preDsRead(r, s, action);
                                }
                            },
                            statusCodeFuncs: {
                                200: function (r, s, m) {

                                    dsRead(r, m);
                                }
                            },
                            complete: function () {

                                // remove the request active flag
                                dse.removeData('requestActive');
                            },
                            fallback: function () {

                                // set the offline flag on the widget, so the widget will know if it needs to behave differently
                                dse.data('offlineWidget', true);

                                var ck = crit && crit.SearchKey ? crit.SearchKey : null;

                                // if there's a criteria search key, try that
                                if (ck) {

                                    // get from cache
                                    var cached = cafm.cache.get(ck);

                                    // if we get an array back
                                    if (isArray(cached)) {

                                        var sort, cachedCriteria = cafm.cache.getObject(crit);

                                        if (cachedCriteria && cafm.util.hasItem(cachedCriteria.SortOptions)) {

                                            var so = cachedCriteria.SortOptions[0];

                                            sort = {
                                                field: so.Field,
                                                dir: cafm.ds.toSortDirString(so.Direction)
                                            };
                                        }
                                        else {

                                            sort = c.dataSource.sort();
                                        }

                                        // create another kendo datasource to sort and page the cached data
                                        var offlineDs = new kendo.data.DataSource({
                                            data: processData(cached),
                                            sort: sort,
                                            pageSize: c.dataSource.pageSize(),
                                            page: c.dataSource.page()
                                        });

                                        // call fetch on the datasource to initialise and the .view() result
                                        offlineDs.fetch(function () {

                                            // carry on as normal with cached data
                                            var offlineRes = offlineDs.view();
                                            offlineRes.Total = offlineDs.total();
                                            dsRead(offlineRes);
                                        });
                                    }
                                }
                                else if (o.DataSourceFallback) {

                                    var data = cafm.util.callFunction(o.DataSourceFallback);
                                    dsRead(data || []);
                                }
                            }
                        });
                    }
                },
                create: cafm.util.getReference(o.DataSourceCreateFunction),
                update: cafm.util.getReference(o.DataSourceUpdateFunction),
                destroy: cafm.util.getReference(o.DataSourceDeleteFunction)
            },
            schema: {

                data: function (r) {

                    return r;
                },
                parse: function (r) {

                    return r;
                },
                total: function (r) {
                    var t = dse.data('total');
                    if (isNullOrUndefined(t)) {
                        t = r.length;
                    }
                    return t;
                },
                model: o.DataSourceModel ? cafm.util.getReference(o.DataSourceModel) : {
                    id: o.PrimaryKeyField.Name
                }
            },
            change: args.dataSourceChanged,
            page: isNum(page) ? page : 1
        };

        // use server paging, sorting
        if (o.UseServerPaging) {

            dso.serverPaging = true;
            dso.serverSorting = true;
        }

        // set page size
        if (o.EnablePaging !== false && o.PageSize > 0) {

            dso.pageSize = o.PageSize;
        }

        // sorting
        if (crit && cafm.util.hasItem(crit.SortOptions)) {

            dso.sort = cafm.util.transformArray(crit.SortOptions, function (so) {

                return {
                    field: so.Field,
                    dir: cafm.ds.toSortDirString(so.Direction)
                };
            });
        }
        else if (o.Sortable && o.SortOptions) {

            dso.sort = cafm.util.transformArray(o.SortOptions, function (so) {

                return {
                    field: so.Field,
                    dir: cafm.ds.toSortDirString(so.Direction)
                };
            });
        }
        else if (o.Sorting && o.Sorting.Default) {

            var sd = o.Sorting.Default;
            dso.sort = {
                field: sd.Field,
                dir: cafm.ds.toSortDirString(sd.Direction)
            };
        }

        // grouping
        if (o.Groupable && o.GroupOptions) {

            dso.group = cafm.util.transformArray(o.GroupOptions, function (go) {

                return {
                    field: go.Field,
                    dir: cafm.ds.toSortDirString(go.Direction)
                };
            });

        }

        // here we give the calling code an opportunity to modify the datasource options
        // useful for modfying the schema / client specific featues
        cafm.util.callFunction(dse.data('preDataSourceCreate'), dso);
        
        // create the data source
        ds = new kendo.data.DataSource(dso);

        return ds;
    },
    toSortDirString: function (enu) {

        return enu === cafm.enums.ListSortDirection.Descending ? 'desc' : 'asc';
    },
    toSortDirEnum: function (str) {

        return str === 'asc' ? cafm.enums.ListSortDirection.Ascending : cafm.enums.ListSortDirection.Descending;
    },
    ensureGridSortOptionsOnCriteria: function (control, criteria) {

        if (!criteria) {
            return;
        }

        var s = control.dataSource.sort();
        s = cafm.util.hasItem(s) ? s[0] : null;
        var currSortF = s ? s.field : null;
        var currSortD = s ? cafm.ds.toSortDirEnum(s.dir) : null;
        var lastSortF = cafm.util.hasItem(criteria.SortOptions) ? criteria.SortOptions[0].Field : null;
        var lastSortD = cafm.util.hasItem(criteria.SortOptions) ? criteria.SortOptions[0].Direction : null;

        if (currSortF === null) {
            criteria.SortOptions = null;
            criteria.HasChanged = true;
        }
        else if (lastSortF != currSortF || lastSortD != currSortD) {

            if (!cafm.util.hasItem(criteria.SortOptions)) criteria.SortOptions = [{}];
            criteria.SortOptions[0].Field = currSortF;
            criteria.SortOptions[0].Direction = currSortD;
            criteria.HasChanged = true;
        }
    },
    ensureGridGroupOptionsOnCriteria: function (control, criteria) {

        var g = control.dataSource.group()[0];
        var currGroupF = g ? g.field : null;
        var currGroupD = g ? cafm.ds.toSortDirEnum(g.dir) : null;
        var lastGroupF = cafm.util.hasItem(criteria.GroupOptions) ? criteria.GroupOptions[0].Field : null;
        var lastGroupD = cafm.util.hasItem(criteria.GroupOptions) ? criteria.GroupOptions[0].Direction : null;

        if (currGroupF === null) {
            criteria.GroupOptions = null;
            criteria.HasChanged = true;
        }
        else if (lastGroupF != currGroupF || lastGroupD != currGroupD) {

            if (!cafm.util.hasItem(criteria.GroupOptions)) criteria.GroupOptions = [{}];
            criteria.GroupOptions[0].Field = currGroupF;
            criteria.GroupOptions[0].Direction = currGroupD;
            criteria.HasChanged = true;
        }
    },
    createSchedulerDataSource: function (args) {

        var dse = args.element;
        var opts = args.options;

        return new kendo.data.SchedulerDataSource({
            batch: true,
            serverPaging: true, // this is required for rebind on scheduler navigate
            transport: {

                read: function (options) {

                    var scheduler = dse.data('kendoScheduler');
                    var v = scheduler.view();

                    var criteria = {
                        StartDate: cafm.web.funcs.fromSessionToUTCDateTime(new Date(v.startDate())),
                        EndDate: cafm.web.funcs.fromSessionToUTCDateTime(cafm.util.moveToEndOfDay(new Date(v.endDate())))
                    }


                    // get the data by executing the action
                    cafm.actions.execute({
                        id: 'schedulerAction',
                        url: opts.DataSourceUrl,
                        values: criteria,
                        beforeExecute: function (args) {

                            // check for pre data source read handler
                            var be = opts.OnPreDataSourceRead;

                            // if there is a handler then call and return it
                            // if false then the request will be stopped
                            if (be) {

                                return cafm.util.callFunction(be, args);
                            }
                            else {

                                return true;
                            }
                        },
                        statusCodeFuncs: {
                            200: function (response) {
                                
                                // call ondataretrieved handler if there is one
                                cafm.handlers.exe(opts.OnDataRetrieved, response, scheduler);

                                // fire success handler
                                options.success(response);
                                                                
                                if(opts.RefreshInterval) {
                                 
                                    if(cafm.ds.schedulerDataSourceTimeout) clearTimeout(cafm.ds.schedulerDataSourceTimeout);
                                    cafm.ds.schedulerDataSourceTimeout = cafm.util.callFunctionAsync({
                                        timeout: (opts.RefreshInterval * 1000),
                                        func: function () {

                                            delete cafm.ds.schedulerDataSourceTimeout;

                                            if (opts.EnsureCurrentDateOnRefresh) {

                                                var now = new Date(), navigatedWhen = scheduler.element.data('navigatedwhen');
                                                if (!cafm.util.datesAreSame(now, scheduler.date()) && (!navigatedWhen || cafm.util.datesMinsDiff(navigatedWhen, now) > 2)) {
                                                    
                                                    scheduler.date(now);
                                                }
                                            }
                                            
                                            scheduler.dataSource.read();
                                        }
                                    })
                                }
                            },
                            401: function () {
                                 
                                if (opts.RefreshInterval) {
                                    window.location.reload();
                                }
                                else {
                                    cafm.auth.notAuthenticated(true);
                                }
                            }
                        },
                        error: function (response) {

                            options.error(response);
                        }
                    });
                },
                update: function (options) {

                    var data;

                    // check for before update handler
                    if (opts.OnBeforeUpdate) {

                        var res = cafm.util.callFunction(opts.OnBeforeUpdate, options);

                        if (res) {

                            data = res;
                        }
                    }

                    if (isNullOrUndefined(data)) {

                        data = options.data.models[0];
                    }

                    // get the data by executing the action
                    cafm.actions.execute({

                        url: opts.UpdateUrl,
                        values: data,
                        loaderTarget: dse[0],
                        loaderText: opts.UpdateLoaderMessage,
                        statusCodeFuncs: {

                            200: function (response) {

                                // check for after update handler
                                if (opts.OnAfterUpdate) {

                                    var res = cafm.util.callFunction(opts.OnAfterUpdate, {
                                        event: data,
                                        response: response
                                    });

                                    if (res) {

                                        data = res;
                                    }
                                }

                                // fire success handler
                                options.success(data);
                            }
                        },
                        error: function (response, status, error) {

                            options.error(response, status, error);
                        }
                    });
                }
            },
            schema: {
                model: cafm.util.getReference(opts.DataSourceModel)
            }
        });
    },
    createTreeViewDataSource: function (args) {
        /// <summary>Creates and returns a tree view data source</summary>
        /// <param name="args" type="Object">The datasource args object</param>
        /// <returns type="kendo.data.HierarchicalDataSource">A Kendo HierarchicalDataSource</returns>

        var dse = args.element;
        var o = args.options;
        var dso = {};

        dso.transport = {
            read: function (options) {

                // if there's an ID this is a dril down request
                if (options.data.Id) {

                    // try to get child items
                    var items = dse.getDataSource().get(options.data.Id).Items;

                    // if there's items already we need not go off to the server
                    if (items) {

                        options.success(items);
                        return;
                    }
                }

                // format the url
                var criteria = o.Criteria,
                    url;
                
                if (!criteria) {

                    urlFormat = '{0}/{1}/{2}',
                        urlArgs = [o.DataSourceUrl, cafm.actions.getObjectInContextId(), (options.data.Id ? options.data.Id : cafm.guid.empty)];

                    if (o.Mode != cafm.enums.TreeViewMode.Unspecified) {

                        urlFormat += '?mode={3}';
                        urlArgs.push(o.Mode);
                    }

                    url = urlFormat.format(urlArgs);
                }
                else {

                    url = o.DataSourceUrl;
                }

                if (o.OnDataSourceUrlGenerated) {

                    // call ondataurlgenerated handler if there is one
                    url = cafm.handlers.exe(o.OnDataSourceUrlGenerated, {
                        url: url,
                        element: dse
                    });
                }

                if (criteria) {

                    if (o.OnPreDataSourceExecute){

                        // call ondataurlgenerated handler if there is one
                        cafm.handlers.exe(o.OnPreDataSourceExecute, {
                            element: dse,
                            options: o,
                            parentId: (options.data && options.data.Id ? options.data.Id : cafm.guid.empty)
                        });
                    }

                    if (options.data && options.data.Page) {

                        criteria.Page = options.data.Page;
                    }
                    else {

                        criteria.Page = 1;
                    }
                }

                // get the data by executing the action
                cafm.actions.execute({
                    url: url,
                    values: criteria,
                    method: o.DataSourceHttpMethod,
                    statusCodeFuncs: {
                        200: function (response) {

                            // call ondataretrieved handler if there is one
                            cafm.handlers.exe(o.OnDataRetrieved, response);

                            if (!response) return;

                            var items = response.Items ? response.Items : response;

                            if ((items && items.length) || !options.data.Id) {

                                if (!response.Page || response.Page < 2) {

                                    // fire success handler
                                    options.success(items);
                                }
                                else
                                {
                                    options.success([]);
                                }

                                // if node child paging is enabled 
                                if (response.Page && response.Total) {
                                    
                                    // render the load on demand node and set paging properties
                                    args.element.data('kendoTreeView').loadMoreOnDemandNode({

                                        response: response,
                                        parentId: options.data.Id
                                    })
                                }
                            }
                            else {
                                
                                options.success([]);
                            }
                        }
                    },
                    error: function (response) {

                        options.error(response);
                    }
                });
            }
        };

        dso.schema = {

            model: {
                id: 'Id',
                hasChildren: 'HasChildren'
            }
        };

        var hds = new kendo.data.HierarchicalDataSource(dso);
        dse.setDataSource(hds);
        return hds;
    },
    currentPage: {
        /// <summary>Client session helper object for caching search page numbers</summary>

        get: function(criteria) {
            /// <summary>Gets the client session cached search page number</summary>
            /// <param name="criteria" type="Object">The search criteria object</param>
            /// <returns type="Integer">The page number</returns>
               
            if (criteria && criteria.CategoryKey && criteria.SearchKey) {

                var key = '{0}_{1}'.format(criteria.CategoryKey, criteria.SearchKey),
                    pageMap = cafm.cache.session.get(cafm.res.consts.CacheKey_CurrentPageMap);

                return !isNullOrUndefined(pageMap) && isObj(pageMap) ? pageMap[key] : 1;
            }
            else {

                return 1;
            }
        },
        set: function (criteria, page) {
            /// <summary>Stores the page number on the client session cache</summary>
            /// <param name="criteria" type="Object">The search criteria object</param>
            /// <param name="page" type="Integer">The page number</param>

            if (criteria && criteria.CategoryKey && criteria.SearchKey) {

                var key = '{0}_{1}'.format(criteria.CategoryKey, criteria.SearchKey),
                    pageMap = cafm.cache.session.get(cafm.res.consts.CacheKey_CurrentPageMap);

                if (isNullOrUndefined(pageMap)) {

                    pageMap = {};
                }

                pageMap[key] = parseInt(page);

                cafm.cache.session.set(cafm.res.consts.CacheKey_CurrentPageMap, pageMap);

            }
        }
    }
}
